module.exports = __webpack_public_path__ + "img/logo_dk@3x.b885ff6f.png";